<template>
  <div class="form-group">
    <label for="name">Veranstaltungsname</label>
    <BootstrapField type="text" name="name" rules="required" />
  </div>
  <div class="form-group" v-if="ticketing_enabled">
    <label for="address">Adresse</label>
    <BootstrapField type="text" name="address" />
    <div class="form-text">In Textform, für mobile Tickets</div>
  </div>
  <div class="form-group" v-if="ticketing_enabled">
    <label>Genaue Position</label>
    <div id="map"></div>
    <div class="form-text">Für mobile Tickets</div>
    <Field type="hidden" name="longitude" ref="longitude" />
    <Field type="hidden" name="latitude" ref="latitude" />
  </div>
  <div class="form-group">
    <label for="start_date">Start Datum</label>
    <BootstrapField type="datetime-local" name="start_date" rules="required" />
  </div>
  <div class="form-group">
    <label for="end_date"
      >End Datum <small>Nutzer sehen das Event danach nichtmehr.</small></label
    >
    <BootstrapField type="datetime-local" name="end_date" />
  </div>
  <div class="form-group" v-if="event.id">
    <div class="form-check">
      <Field
        type="checkbox"
        name="unset_end_date"
        id="unset_end_date"
        class="form-check-input"
        :value="true"
      />
      <label class="form-check-label" for="unset_end_date">
        Enddatum entfernen
      </label>
    </div>
  </div>
  <div class="form-group" v-if="ticketing_enabled">
    <label for="ticket_send_date">Ticket Versand ab</label>
    <BootstrapField type="datetime-local" name="ticket_send_date" />
  </div>
  <div class="form-group" v-if="ticketing_enabled && event.id">
    <div class="form-check">
      <Field
        type="checkbox"
        name="unset_ticket_send_date"
        id="unset_ticket_send_date"
        class="form-check-input"
        :value="true"
      />
      <label class="form-check-label" for="unset_ticket_send_date">
        Versanddatum entfernen
      </label>
    </div>
  </div>
  <div class="form-group" v-if="ticketing_enabled">
    <label for="min_required_shifts"
      >Mindestanzahl an belegten Schichten für ein Ticket</label
    >
    <BootstrapField type="number" name="min_required_shifts" />
    <div class="form-text">
      Sollte bei nur geändert werden, wenn sich noch kein Nutzer in Schichten
      eingetragen hat.
    </div>
  </div>
  <div class="form-group">
    <div class="form-check">
      <Field
        type="checkbox"
        name="is_public"
        id="is_public"
        class="form-check-input"
        :value="true"
      />
      <label class="form-check-label" for="is_public">
        Das Event veröffentlichen
      </label>
    </div>
  </div>
</template>

<script>
import { Field } from "vee-validate";
import BootstrapField from "./BootstrapField.vue";
import * as L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerPng from "@/assets/img/marker-icon-2x.png";
import markerShadowPng from "@/assets/img/marker-shadow.png";
import { useConfigStore } from "@/stores/config";
import { mapState } from "pinia";

export default {
  name: "EventForm",
  components: { BootstrapField, Field },
  props: ["event", "setFieldValue"],
  data() {
    return {
      map: {},
      marker: {},
    };
  },
  mounted() {
    if (this.ticketing_enabled) {
      this.map = L.map("map").setView(
        [this.event.latitude, this.event.longitude],
        8
      );
      L.tileLayer("https://a.tile.openstreetmap.de/{z}/{x}/{y}.png ", {
        maxZoom: 19,
        attribution: "© OpenStreetMap",
      }).addTo(this.map);
      this.map.on("click", this.setMarker);
      this.marker = L.marker([this.event.latitude, this.event.longitude], {
        icon: new L.Icon({
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          tooltipAnchor: [16, -28],
          shadowSize: [41, 41],
          iconUrl: markerPng,
          shadowUrl: markerShadowPng,
        }),
      }).addTo(this.map);
    }
  },
  computed: {
    ...mapState(useConfigStore, ["ticketing_enabled"]),
  },
  methods: {
    async setMarker(click) {
      this.marker.setLatLng(click.latlng);
      this.setFieldValue("latitude", click.latlng.lat);
      this.setFieldValue("longitude", click.latlng.lng);
    },
  },
};
</script>

<style scoped>
#map {
  height: 300px;
}
</style>
